// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'flag-finish';

export const Component = () => (
  <path d='M20.194.958H5.874C5.635.335 5.155 0 4.485 0c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 3 1.485v21.552c0 .431.144.766.431 1.054.288.287.623.43 1.054.43.431 0 .767-.143 1.054-.43.288-.288.431-.623.431-1.054v-8.334h14.225c.43 0 .766-.144 1.053-.431a1.58 1.58 0 0 0 .383-1.054V2.442a1.58 1.58 0 0 0-.383-1.054 1.408 1.408 0 0 0-1.053-.431h-.001Zm-15.23.526v21.553c0 .335-.144.479-.479.479-.335 0-.479-.144-.479-.48V1.487c0-.336.144-.527.48-.527.334 0 .478.191.478.526Zm15.709.958v2.442h-2.97v2.97h2.97v2.921h-2.97v2.97h-2.921v-2.97h-2.921v2.97H8.89v-2.97H5.97V7.854h2.92v-2.97H5.97v-2.92h2.92v2.92h2.97v-2.92h2.921v2.92h2.921v-2.92h2.49c.336 0 .48.143.48.478Zm-5.891 5.413h-2.921v-2.97h2.921v2.97Zm0 2.92v-2.92h2.921v2.92h-2.921Zm-5.89-2.92h2.969v2.92H8.89v-2.92Z' />
);

export const viewBox = '0 0 25 25';
